import { render } from "./LearnToDrink.vue?vue&type=template&id=34998e02&scoped=true"
import script from "./LearnToDrink.vue?vue&type=script&lang=js"
export * from "./LearnToDrink.vue?vue&type=script&lang=js"

import "./LearnToDrink.vue?vue&type=style&index=0&id=34998e02&lang=scss&scoped=true"

import exportComponent from "/Users/andreigeana/Documents/Projects/KidsStuff/babies/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34998e02"]])

export default __exports__